<template>
  <div class="section_header">
    <h3 v-if="Object.keys(vessel).length > 0">{{ title }}</h3>
    <p v-if="vessel.type"><span class="label" >{{$t('type', 'en')}}:</span> {{  $t('vessels.' + vessel.type, 'en') }}</p>
    <p v-if="vessel.name"><span class="label">{{$t('name', 'en')}}:</span> {{ vessel.name }}</p>
    <p v-if="vessel.registration"><span class="label">{{$t('registration', 'en')}}:</span> {{ vessel.registration }}</p>
    <p v-if="vessel.imo"><span class="label">{{$t('imo', 'en')}}:</span> {{ vessel.imo }}</p>
    <p v-if="vessel.mmsi"><span class="label">{{$t('mmsi', 'en')}}:</span> {{ vessel.mmsi }}</p>
    <p v-if="vessel.call_sign"><span class="label">{{$t('call_sign', 'en')}}:</span> {{ vessel.call_sign }}</p>
    <p v-if="vessel.mode_s"><span class="label">{{$t('mode_s', 'en')}}:</span> {{ vessel.mode_s }}</p>
    <p v-if="vessel.serial"><span class="label">{{$t('serial', 'en')}}:</span> {{ vessel.serial }}</p>
    <p v-if="vessel.brand"><span class="label">{{$t('brand', 'en')}}:</span> {{ vessel.brand }}</p>
    <p v-if="vessel.model"><span class="label">{{$t('model', 'en')}}:</span> {{ vessel.model }}</p>
    <p v-if="vessel.year_of_build"><span class="label">{{$t('year_of_build', 'en')}}:</span> {{ vessel.year_of_build }}</p>
    <p v-if="vessel.length"><span class="label">{{$t('length', 'en')}}:</span> {{ vessel.length }}</p>
    <p v-if="vessel.airline"><span class="label">{{$t('airline', 'en')}}:</span> {{ vessel.airline }}</p>
    <p v-if="vessel.tonnage"><span class="label">{{$t('tonnage', 'en')}}:</span> {{ vessel.tonnage }}</p>
    <p v-if="vessel.weight"><span class="label">{{$t('weight', 'en')}}:</span> {{ vessel.weight }}</p>
    <p v-if="vessel.hull_colour"><span class="label">{{$t('hull_colour', 'en')}}:</span> {{ vessel.hull_colour }}</p>
    <p v-if="vessel.colour"><span class="label">{{$t('colour', 'en')}}:</span> {{ vessel.colour }}</p>
    <p v-if="vessel.home_airbase"><span class="label">{{$t('home_airbase', 'en')}}:</span> {{ vessel.home_airbase  }}</p>
    <p v-if="vessel.flag"><span class="label">{{$t('flag', 'en')}}:</span> {{  $t('countries.' + vessel.flag, 'en') }}</p>
    <p v-if="vessel.last_position"><span class="label">{{$t('last_position', 'en')}}:</span> {{ vessel.last_position }}</p>
    <p v-if="vessel.distinguishing_features"><span class="label">{{$t('distinguishing_features', 'en')}}:</span> {{ vessel.distinguishing_features }}</p>
    <p v-if="vessel.monitoring && vessel.monitoring.vesselControl">
      <span class="label">Control Type:</span> {{ $t(vessel.monitoring.vesselControlType, 'en') }}
    </p>
    <p v-if="actionRequired(vessel)">
      <span class="label">{{ $t('action_required', 'en')}}:</span> {{ formatVesselRequiredActions(vessel) }}
    </p>
  </div>
</template>

<script>
import { ExportUtils } from '../../services/DataExport'
import { VesselUtils } from '../../services/VesselUtils'

export default {
  name: 'VesselPreview',
  props: {
    title: String,
    vessel: Object
  },
  data: vm => ({
  }),
  methods: {
    actionRequired (details) {
      return VesselUtils.vesselActionRequired(details)
    },
    formatVesselRequiredActions (vessel) {
      return ExportUtils.formatVesselRequiredActions(vessel)
    }
  }
}
</script>
